import React from 'react'
import { AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Box, Stack, Text, Checkbox, StackDivider } from '@chakra-ui/react'

export const SearchFilterItem = ({ title, options, selectedItems, onChange, isDisabled = false }) => {
  return (
    <AccordionItem border="none" isDisabled={isDisabled}>
      {({ isExpanded }) => (
        <>
          <AccordionButton px={2} py={4} fontSize="sm" gap={2} _hover={{ bg: 'inherit' }}>
            <Stack w="100%" textAlign="left">
              <Box flex="1" fontWeight="semibold">
                {title}
              </Box>
              {selectedItems.length > 0 && (
                <Text fontSize="3xs" color="label.link">
                  {selectedItems.map((v) => options.find((opt) => opt.value === v)?.label || v).join('、')}
                </Text>
              )}
            </Stack>
            {isExpanded && (
              <Text
                as="span"
                fontSize="2xs"
                flexShrink={0}
                color={selectedItems.length > 0 ? 'label.link' : 'label.tertiary'}
                onClick={(e) => {
                  e.preventDefault()
                  onChange([])
                }}
              >
                クリア
              </Text>
            )}
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel bgColor="bg.secondary" p={0}>
            <Stack spacing={0} divider={<StackDivider />}>
              {options.map(({ label, value }) => (
                <Checkbox
                  key={value}
                  value={value}
                  px={2}
                  py={4}
                  borderColor="divider.dark"
                  isChecked={selectedItems.includes(value)}
                  onChange={() => {
                    if (selectedItems.includes(value)) {
                      onChange(selectedItems.filter((item) => item !== value))
                    } else {
                      onChange([...selectedItems, value])
                    }
                  }}
                >
                  <Text fontSize="xs">{label}</Text>
                </Checkbox>
              ))}
            </Stack>
          </AccordionPanel>
        </>
      )}
    </AccordionItem>
  )
}
